import Vue from "vue";
import {
  UPDATE_IS_DEALER_MICRO_SITE,
  UPDATE_DEALER_NAME
} from "@/store/mutationTypes";

export default {
  [UPDATE_IS_DEALER_MICRO_SITE](state, isDealerMicroSite) {
    Vue.set(state, "isDealerMicroSite", isDealerMicroSite);
  },
  [UPDATE_DEALER_NAME](state, dealerName) {
    Vue.set(state, "dealerName", dealerName);
  }
};
